import api from './api';

export const assetFinanceService = {
  getAssetLoans: async (params = {}) => {
    try {
      const response = await api.get('/finance/assets/loans', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getAssetLoan: async (id) => {
    try {
      const response = await api.get(`/finance/assets/loans/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createAssetLoan: async (data) => {
    try {
      const response = await api.post('/finance/assets/loans', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateAssetLoan: async (id, data) => {
    try {
      const response = await api.put(`/finance/assets/loans/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteAssetLoan: async (id) => {
    try {
      const response = await api.delete(`/finance/assets/loans/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getFinancingOptions: async (assetId) => {
    try {
      const params = assetId ? { assetId } : {};
      const response = await api.get('/finance/assets/financing-options', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getPaymentSchedule: async (loanId) => {
    try {
      const response = await api.get(`/finance/assets/payment-schedule/${loanId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  processPayment: async (data) => {
    try {
      const response = await api.post('/finance/assets/process-payment', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getAnalytics: async () => {
    try {
      const response = await api.get('/finance/assets/analytics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
